var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-template-message-list" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("whatsapp_business_api.templates"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex gap-5" },
          [
            _c(
              "a-button",
              {
                attrs: { type: "primary", ghost: "" },
                on: { click: _vm.gotoCreatePage },
              },
              [
                _c("a-icon", { attrs: { type: "plus" } }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("whatsapp_business_api.createNewTemplate")) +
                    "\n            "
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: { type: "primary", ghost: "" },
                on: { click: _vm.refreshTemplates },
              },
              [_vm._v(_vm._s(_vm.$t("message.refresh")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("a-input-search", {
        staticStyle: { "margin-bottom": "16px" },
        attrs: { placeholder: "Şablon ara..." },
        model: {
          value: _vm.searchQuery,
          callback: function ($$v) {
            _vm.searchQuery = $$v
          },
          expression: "searchQuery",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            { staticClass: "templates" },
            _vm._l(_vm.filteredTemplates, function (template) {
              return _c("TemplateCard", {
                key: template.id,
                attrs: {
                  template: template,
                  "on-click": function () {
                    return (_vm.selectedTemplate = template)
                  },
                  selected:
                    _vm.selectedTemplate &&
                    _vm.selectedTemplate.id === template.id,
                },
                on: { deleteTemplate: _vm.cbDeleteTemplate },
              })
            }),
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          _c(
            "div",
            { staticClass: "preview-container" },
            [
              _vm.selectedTemplate
                ? _c("WhatsappMessagePreview", {
                    attrs: {
                      body: _vm.getTemplateParameters(_vm.selectedTemplate)
                        .body,
                      footer: _vm.getTemplateParameters(_vm.selectedTemplate)
                        .footer,
                      "header-media-type": _vm.getTemplateParameters(
                        _vm.selectedTemplate
                      ).headerType,
                      "header-text": _vm.getTemplateParameters(
                        _vm.selectedTemplate
                      ).headerText,
                      buttons: _vm.getTemplateParameters(_vm.selectedTemplate)
                        .buttons,
                      headerMediaURL: _vm.getTemplateParameters(
                        _vm.selectedTemplate
                      ).headerMediaURL,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }